import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { webColors, webBorderRadius, webShadows } from '../../../../constants/webStyles';
import AuthHeader from '../components/AuthHeader.web';
import BrandingPanel from '../components/BrandingPanel.web';

const StepSuccess = ({ onShowLogin }) => {
  return (
    <View style={styles.pageContainer}>
      {/* Header */}
      <AuthHeader
        currentView="success"
        onShowLogin={onShowLogin}
        onShowRegister={() => {}}
      />

      {/* Main Content */}
      <View style={styles.mainContainer}>
        {/* Left Side - Branding */}
        <BrandingPanel />

        {/* Right Side - Success Content */}
        <ScrollView style={styles.formSide} contentContainerStyle={styles.formSideContent}>
          <View style={styles.container}>
            <View style={styles.content}>
              <View style={styles.successIcon}>
                <Text style={styles.successCheckmark}>✓</Text>
              </View>
              <Text style={styles.successTitle}>Welcome to SuperMedic!</Text>
              <Text style={styles.successMessage}>
                Your facility account has been created successfully.{'\n'}
                Please sign in to access your dashboard.
              </Text>
              <TouchableOpacity
                style={styles.btnDashboard}
                onPress={onShowLogin}
              >
                <Text style={styles.btnDashboardText}>Sign In</Text>
              </TouchableOpacity>
            </View>
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
    backgroundColor: webColors.background,
    minHeight: '100vh',
  },
  mainContainer: {
    flex: 1,
    flexDirection: 'row',
    minHeight: 'calc(100vh - 80px)',
  },
  formSide: {
    flex: 1,
    backgroundColor: webColors.cardBackground,
  },
  formSideContent: {
    padding: 40,
    justifyContent: 'center',
    minHeight: '100%',
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  content: {
    alignItems: 'center',
    maxWidth: 480,
    width: '100%',
  },
  successIcon: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: '#22c55e',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    shadowColor: '#22c55e',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.3,
    shadowRadius: 25,
  },
  successCheckmark: {
    fontSize: 40,
    color: '#ffffff',
    fontWeight: '700',
  },
  successTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 12,
    textAlign: 'center',
  },
  successMessage: {
    fontSize: 16,
    color: '#6b7280',
    textAlign: 'center',
    lineHeight: 26,
    marginBottom: 32,
  },
  btnDashboard: {
    width: '100%',
    backgroundColor: webColors.primary,
    paddingVertical: 16,
    borderRadius: webBorderRadius.medium,
    alignItems: 'center',
    ...webShadows.button,
  },
  btnDashboardText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
  },
});

export default StepSuccess;
